const components = {
  DsfAuditState: dsf.defineAsyncComponent("DsfAuditState", () =>
    import(/*webpackChunkName:"platform_pc_form"*/ "./auditState.vue")
  ),
  DsfAuditStateListForm: dsf.defineAsyncComponent("DsfAuditStateListForm", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_state"*/ "./auditStateForm.vue"
    )
  ),
};

const install = dsf.createDsfVueInstall("platform", components);

export { install };
export default install;
